import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Injeta ou remove o bootstrap.css dependendo da rota atual
 */
function BootstrapManager({
  location,
}) {
  useEffect(() => {
    const cssFiles = [
      '/css/bootstrap.css',
      '/css/vendors.css',
      '/css/menu.css',
      '/css/date_picker.css',
      '/css/tables.css',
    ];

    const isDashboard = location.pathname.startsWith('/dashboard');

    if (!isDashboard) {
      // Adiciona todos os arquivos CSS, se ainda não estiverem no DOM
      cssFiles.forEach((href) => {
        const id = href; // usar o próprio path como id único
        if (!document.getElementById(id)) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.id = id;
          link.href = href;
          document.head.appendChild(link);
          console.info(`[CSS] added: ${href}`);
        }
      });
    } else {
      // Remove todos os arquivos CSS públicos quando entra no dashboard
      cssFiles.forEach((href) => {
        const link = document.getElementById(href);
        if (link) {
          link.remove();
          console.info(`[CSS] removed: ${href}`);
        }
      });
    }
  }, [location.pathname]);

  return null;
}

export default withRouter(BootstrapManager);
